import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { CategoryFileFragmentDoc } from '../../fragment/generated/CategoryFile';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateCategoryMutationVariables = Types.Exact<{
  data: Types.CreateFileInput;
}>;


export type CreateCategoryMutation = { createFile?: { file?: { id: string, name: string, purpose?: Types.FilePurposeEnum | null, childrenIds?: Array<string> | null, category: Types.FileCategoryEnum, contentCount?: number | null, subWorkspaces?: Array<string> | null } | null } | null };


export const CreateCategoryDocument = /*#__PURE__*/ gql`
    mutation CreateCategory($data: CreateFileInput!) {
  createFile(data: $data) {
    file {
      ...CategoryFile
    }
  }
}
    ${CategoryFileFragmentDoc}`;

export function useCreateCategoryMutation() {
  return Urql.useMutation<CreateCategoryMutation, CreateCategoryMutationVariables>(CreateCategoryDocument);
};